import React from 'react';
import Highcharts, { SeriesOptionsType } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import COLORS, { chartGradientColors } from '../../core/constants/colors';
import { BarChartModel } from '../../core/models/power';

export interface IBarChart {
  data: BarChartModel[];
}

function getPowerGeneration(powerGeneration: BarChartModel[]): [SeriesOptionsType[], number] {
  const additionalSeries: SeriesOptionsType[] = [];
  const data = [...powerGeneration];
  const maxPerRow: number[] = [];

  let returnedSeries: SeriesOptionsType[] = [];

  returnedSeries = data.map((item, index) => {
    return {
      color: chartGradientColors[index],
      name: item.series[0].name,
      stack: `stack-${index}`,
      type: 'bar',
      data: item.series[0].data,
    };
  });

  // Calculate maximum from each series
  data.forEach((value) => {
    maxPerRow.push(Math.max.apply(null, value.series[0].data));
  });

  // Calculate maximum from maxPerRow
  let max = Math.ceil(Math.max.apply(null, maxPerRow));
  // Make max always even number, for better display
  max = max % 2 === 1 ? max + 1 : max;

  // We create 2 series, what will be rest of the total
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  returnedSeries.forEach((responseSeries: any) => {
    additionalSeries.push({
      stack: responseSeries.stack,
      color: COLORS.barChart,
      type: 'bar',
      data: responseSeries.data.map((reponseData: number) => max - reponseData),
      showInLegend: false,
      enableMouseTracking: false,
    });
  });

  // Put in front of the originalSeries auxiliar series
  additionalSeries.forEach((series) => {
    returnedSeries.unshift(series);
  });

  return [returnedSeries, max];
}

const BarChart = React.memo(function BarChart({ data }: IBarChart): JSX.Element {
  const [chartData, yAxisMax] = getPowerGeneration(data);

  const options: Highcharts.Options = {
    chart: {
      type: 'bar',
      backgroundColor: 'transparent',
      animation: false,
    },

    credits: {
      enabled: false,
    },

    title: {
      text: undefined,
    },

    subtitle: {
      text: undefined,
    },

    xAxis: {
      categories: [...data[0].categories],
      lineWidth: 0,
      labels: {
        style: {
          fontWeight: '600',
          fontSize: '14px',
          lineHeight: '24px',
          color: COLORS.content,
        },
        align: 'left',
        x: 0,
        y: -12,
      },
      title: {
        text: 'GW',
        style: {
          color: COLORS.content,
          fontWeight: '600',
          fontSize: '13px',
          fontStyle: 'normal',
          lineHeight: '18px',
        },
      },
    },

    yAxis: [
      {
        title: {
          text: undefined,
        },
        max: yAxisMax,
        gridLineWidth: 0,
        gridLineColor: COLORS.backgroundSecond,
        lineWidth: 1,
        tickWidth: 1,
        opposite: true,
      },
      {
        title: {
          text: undefined,
        },
        max: yAxisMax,
        gridLineWidth: 0,
        gridLineColor: COLORS.backgroundSecond,
        lineWidth: 1,
        tickWidth: 1,
        opposite: false,
        linkedTo: 0,
      },
    ],

    tooltip: {
      valueDecimals: 2,
    },

    plotOptions: {
      series: {
        stacking: 'normal',
        animation: false,
      },
      bar: {
        borderWidth: 0,
        pointWidth: 6,
        groupPadding: 0.35,
        borderRadius: 4,
        dataLabels: {
          enabled: false,
        },
      },
    },
    legend: {
      align: 'left',
    },
    series: [...chartData],
  };
  return (
    <div className="BarChart">
      <h3>UK Power Generation Mix 15 last days</h3>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
});

export default BarChart;
